import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PayeePickerHeader from './PayeePickerHeader';
import { pickerLayoutStyles } from '../../PickerLayoutStyles';
import { payeePropTypes } from '../../../managePayee/states/propTypes';
import { accountPropTypes } from '../../../sharedComponents/PayeeList/propTypes';
import { getPayeeType } from '../../../managePayee/states/selectors';
import { setPayeeType } from '../../../managePayee/states/action';
import { TYPE_DOMESTIC_PAYEE, TYPE_IFT_PAYEE } from '../../../config';
import {
	getPayeesForCurrentPage,
	getShowPayees,
	getPayeesNeverFetched,
	getShowPayeePickerToggle,
	getCurrentPageInfo,
	getPageLoading,
	getAccountsForCurrentPage,
	getErrorFlag,
	getSearchText,
	getAccountsNeverFetched,
	getPagingLayoutType,
	getIsPayeesSearchFilterOn,
	getIsAccountsSearchFilterOn,
} from '../../../states/accountPaging/selectors';
import { setShowPayees, resetPagedPayees } from '../../../states/accountPaging/actions';
import PayeePickerPagingView from './PayeePickerPagingView';
import { isIFTEnabled } from '../../../states/capabilities/selectors';
import { getSelectedFromAccount } from '../../../states/payeeSelector/selectors';
import { getFavouriteAccountsForPicker } from '../../../states/favourites/selectors';
import { swiftChars } from '../../../utils/payeeUtils';

const mapState = (state) => ({
	payeeType: getPayeeType(state),
	payees: getPayeesForCurrentPage(state),
	showPayees: getShowPayees(state),
	isIFTEnabled: isIFTEnabled(state),
	payeesNeverFetched: getPayeesNeverFetched(state),
	showPayeePickerToggle: getShowPayeePickerToggle(state),
	currentPageInfo: getCurrentPageInfo(state),
	pageLoading: getPageLoading(state),
	accounts: getAccountsForCurrentPage(state),
	error: getErrorFlag(state),
	searchText: getSearchText(state),
	accountsNeverFetched: getAccountsNeverFetched(state),
	fromAccount: getSelectedFromAccount(state),
	layoutType: getPagingLayoutType(state),
	favourites: getFavouriteAccountsForPicker(state),
	isPayeesSearchFilterOn: getIsPayeesSearchFilterOn(state),
	isAccountsSearchFilterOn: getIsAccountsSearchFilterOn(state),
});

const mapDispatch = (dispatch) => ({
	setShowPayees: (showPayees) => dispatch(setShowPayees(showPayees)),
	setPayeeType: (type) => dispatch(setPayeeType(type)),
	resetPagedPayees: (type) => dispatch(resetPagedPayees(type)),
});
export class PayeePicker extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showListView: false,
		};

		this.onShowPayees = this.onShowPayees.bind(this);
		this.onShowAccounts = this.onShowAccounts.bind(this);
		this.handleListViewToggle = this.handleListViewToggle.bind(this);
		this.handleSearchTextChanged = this.handleSearchTextChanged.bind(this);
		this.onUKPayees = this.onUKPayees.bind(this);
		this.onInternationalPayees = this.onInternationalPayees.bind(this);
	}
	componentDidMount() {
		const { initializeGetPage, payeesNeverFetched } = this.props;
		if (payeesNeverFetched) {
			initializeGetPage(1);
		}
	}

	componentWillUnmount() {
		const { resetPagedPayees, isBootStrapInProgress } = this.props;
		if (!isBootStrapInProgress) {
			resetPagedPayees();
		}
	}

	onShowPayees() {
		const { setShowPayees, resetPagedPayees, onPageChanged } = this.props;
		resetPagedPayees();
		setShowPayees(true);
		onPageChanged(1);
	}

	onShowAccounts() {
		const { onPageChanged, setShowPayees, resetPagedPayees, searchText, onSearchTextChanged } = this.props;
		setShowPayees(false);
		resetPagedPayees();
		onPageChanged(1);
		if (searchText) {
			onSearchTextChanged('');
		}
	}
	onUKPayees() {
		const { setPayeeType, onPageChanged, resetPagedPayees } = this.props;
		setPayeeType(TYPE_DOMESTIC_PAYEE);
		resetPagedPayees();
		onPageChanged(1);
	}

	onInternationalPayees() {
		const { setPayeeType, onPageChanged, resetPagedPayees } = this.props;
		setPayeeType(TYPE_IFT_PAYEE);
		resetPagedPayees();
		onPageChanged(1);
	}

	handleListViewToggle(value) {
		this.setState({
			showListView: value,
		});
	}

	handleSearchTextChanged(text) {
		const {
			onSearchTextChanged,
			isPayeesSearchFilterOn,
			isAccountsSearchFilterOn,
			onPageChanged,
			showPayees,
			isPaymentFlow,
		} = this.props;
		if (isPaymentFlow && !showPayees && isAccountsSearchFilterOn && !text) {
			onSearchTextChanged('');
			onPageChanged(1);
			return;
		}
		onSearchTextChanged(swiftChars(text));
		if (isPayeesSearchFilterOn) {
			onPageChanged(1);
		}
	}

	render() {
		const { showListView } = this.state;
		const {
			payees,
			currentPageInfo,
			pageLoading,
			onPageChanged,
			error,
			onRetry,
			searchText,
			accountsNeverFetched,
			layoutType,
			accounts,
			showPayees,
			handlePayeeSelect,
			getIsPayeeSelected,
			isManageYourPayee,
			payeeType,
			handleViewPayee,
			handleDeletePayee,
			handleDisplayFullwidth,
			handleEditPayee,
			handleEditChaps,
			handleImportPayees,
			isFileImportAllowed,
			handleTransferPayee,
			isIFTEnabled,
			fromAccount,
			payeesNeverFetched,
			onSearchTextSubmit,
			handleFavouriteIconClick,
			showPayeePickerToggle,
			onSearchTextChanged,
			handleGoBack,
			isBootStrapInProgress,
			selectedPayees,
		} = this.props;
		const { currentPage, totalNumberOfPages } = currentPageInfo;

		return (
			<div className={pickerLayoutStyles}>
				<PayeePickerHeader
					onToggleListView={this.handleListViewToggle}
					onShowPayees={this.onShowPayees}
					onShowAccounts={this.onShowAccounts}
					onUKPayees={this.onUKPayees}
					onInternationalPayees={this.onInternationalPayees}
					onSearchTextChange={this.handleSearchTextChanged}
					listViewSelected={showListView}
					showPayees={showPayees}
					searchText={searchText}
					isManageYourPayee={isManageYourPayee}
					ukPayees={payeeType === TYPE_DOMESTIC_PAYEE}
					isIFTEnabled={isIFTEnabled}
					fromAccount={fromAccount}
					onSearchTextSubmit={onSearchTextSubmit}
					pageLoading={pageLoading}
					showPayeePickerToggle={showPayeePickerToggle}
					selectedPayees={selectedPayees}
					handleDisplayFullwidth={handleDisplayFullwidth}
				/>
				<PayeePickerPagingView
					currentPage={currentPage}
					totalNumberOfPages={totalNumberOfPages}
					pageLoading={pageLoading}
					onPageChanged={onPageChanged}
					payees={payees}
					listViewSelected={showListView}
					onFavouriteIconClick={handleFavouriteIconClick}
					error={error}
					onRetry={onRetry}
					searchText={searchText}
					accountsNeverFetched={accountsNeverFetched}
					layoutType={layoutType}
					showPayees={showPayees}
					accounts={accounts}
					handlePayeeSelect={handlePayeeSelect}
					getIsPayeeSelected={getIsPayeeSelected}
					isManageYourPayee={isManageYourPayee}
					handleViewPayee={handleViewPayee}
					handleDeletePayee={handleDeletePayee}
					handleEditPayee={handleEditPayee}
					handleEditChaps={handleEditChaps}
					handleImportPayees={handleImportPayees}
					isFileImportAllowed={isFileImportAllowed}
					handleTransferPayee={handleTransferPayee}
					payeesNeverFetched={payeesNeverFetched}
					onSearchTextChanged={onSearchTextChanged}
					handleGoBack={handleGoBack}
					onSearchTextSubmit={onSearchTextSubmit}
					showAccountPicker={!isManageYourPayee && !showPayees}
					isBootStrapInProgress={isBootStrapInProgress}
				/>
			</div>
		);
	}
}

PayeePicker.propTypes = {
	onSearchTextChanged: PropTypes.func.isRequired,
	onPageChanged: PropTypes.func.isRequired,
	setShowPayees: PropTypes.func.isRequired,
	payees: PropTypes.arrayOf(PropTypes.shape(payeePropTypes)),
	selectedPayees: PropTypes.arrayOf(PropTypes.shape(payeePropTypes)),
	accounts: PropTypes.arrayOf(PropTypes.shape(accountPropTypes).isRequired),
	currentPageInfo: PropTypes.shape({
		currentPage: PropTypes.number.isRequired,
		totalNumberOfPages: PropTypes.number.isRequired,
	}),
	pageLoading: PropTypes.bool.isRequired,
	error: PropTypes.bool.isRequired,
	onRetry: PropTypes.func.isRequired,
	searchText: PropTypes.string.isRequired,
	accountsNeverFetched: PropTypes.bool.isRequired,
	layoutType: PropTypes.string.isRequired,
	showPayees: PropTypes.bool.isRequired,
	handlePayeeSelect: PropTypes.func,
	getIsPayeeSelected: PropTypes.func,
	isManageYourPayee: PropTypes.bool,
	setPayeeType: PropTypes.func,
	payeeType: PropTypes.bool,
	handleViewPayee: PropTypes.func,
	handleDeletePayee: PropTypes.func,
	handleDisplayFullwidth: PropTypes.func,
	handleEditPayee: PropTypes.func,
	handleImportPayees: PropTypes.func,
	isFileImportAllowed: PropTypes.bool,
	isIFTEnabled: PropTypes.bool,
	payeesNeverFetched: PropTypes.bool,
	handleTransferPayee: PropTypes.func,
	resetPagedPayees: PropTypes.func.isRequired,
	fromAccount: PropTypes.string,
	onSearchTextSubmit: PropTypes.func.isRequired,
	handleFavouriteIconClick: PropTypes.func.isRequired,
	showPayeePickerToggle: PropTypes.bool.isRequired,
	handleGoBack: PropTypes.func,
	isBootStrapInProgress: PropTypes.bool,
	initializeGetPage: PropTypes.func.isRequired,
	isPayeesSearchFilterOn: PropTypes.bool.isRequired,
	isAccountsSearchFilterOn: PropTypes.bool.isRequired,
	isPaymentFlow: PropTypes.bool.isRequired,
};

export default connect(mapState, mapDispatch)(PayeePicker);
